import type { ProgetAppReleaseOutput } from '@mxa-argos/core/graphql/graphql';
import type { ForjaApk } from '@mxa-argos/modules/forja/interfaces/forja-apk.interface';
import type { ForjaEngineEvents } from '@mxa-argos/modules/forja/lib/engine/forja-engine-events';
import { downloadApk } from '@mxa-argos/modules/forja/services/forja-ops.service';

// The returned order is the install order.
export async function downloadApks(
  releases: ProgetAppReleaseOutput[],
  events: ForjaEngineEvents,
): Promise<ForjaApk[]> {
  const apks: ForjaApk[] = [];
  const total = releases.length;

  for (const [position, release] of releases.entries()) {
    const index = position + 1;

    events.emit({
      type: 'download',
      progetApplicationUUID: release.progetApplicationUUID,
      packageName: release.packageName,
      version: release.version,
      index,
      total,
      state: 'started',
      sizeBytes: null,
    });

    const apk = await downloadApk(release);

    events.emit({
      type: 'download',
      progetApplicationUUID: release.progetApplicationUUID,
      packageName: release.packageName,
      version: release.version,
      index,
      total,
      state: apk.wasCached ? 'cached' : 'downloaded',
      sizeBytes: apk.blob.size,
    });

    apks.push(apk);
  }

  return apks;
}
